import { z } from 'zod'

export const ADMINANALYTICSREPORTSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminAnalyticsReportsGetResponseSchema = z.unknown()
export type AdminAnalyticsReportsGetResponse = z.infer<typeof adminAnalyticsReportsGetResponseSchema>
